module.exports = __webpack_public_path__ + "media/images/google_calendar-f7cb6fb189e06abefddecf4de4bd5b65.svg";